import React from "react";
import PageWrapper from "../shared/PageWrapper";
import AccountDetails from "./components/AccountDetails";
import { DeleteAccountButton } from "./components/DeleteAccountButton";
import { LinkedAccounts } from "./components/LinkedAccounts";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";

const AccountPage: React.FC = () => {
  return (
    <PageWrapper title="Your Account" data-test-id="account-page__back-button">
      <div className="card">
        <div className="card-body">
          <h4 className="pb-0 mb-0 cpl-text-primary mt-4">Your Details</h4>
          <AccountDetails />

          <div className="d-flex align-items-end justify-content-between">
            <h4 className="pb-0 mb-0 cpl-text-primary mt-4">Linked Accounts</h4>
            <Link
              className="cpl-btn cpl-btn-primary d-flex gap-2"
              to={"/AddAccount"}
              data-test-id="linked-account__add-account-button"
            >
              <span>
                <FontAwesomeIcon icon={faPlus} className="pt-1" />
              </span>
              Add Account
            </Link>
          </div>
          <LinkedAccounts />
        </div>
      </div>
      <DeleteAccountButton data-test-id="account-page__delete-account-button" />
    </PageWrapper>
  );
};

export { AccountPage };
